export default {
    methods: {

    },
    mounted() {
        let component = this;
        jQuery('.ql-bold').attr('aria-label', this.$lang('Pogrubienie'));
        jQuery('.ql-header .ql-picker-item').each(function (index, element) {
            let item = $(element);
            let desc = '';
            if (index === 0) {
                desc = component.$lang('Normalna');
            } else {
                desc = component.$lang('Nagłówek') + ' ' + item.attr('data-value');
            }
            item.attr('aria-label', desc);
        });
        jQuery('.ql-header .ql-picker-label').attr('aria-label', this.$lang('Wielkość czcionki'));

        jQuery('.ql-italic').attr('aria-label', this.$lang('Kursywa'));
        jQuery('.ql-underline').attr('aria-label', this.$lang('Podkreślenie'));
        jQuery('.ql-strike').attr('aria-label', this.$lang('Przekreślenie'));
        jQuery('.ql-align[value="center"]').attr('aria-label', this.$lang('Wyrównanie do środka'));
        jQuery('.ql-align[value="justify"]').attr('aria-label', this.$lang('Justowanie'));
        jQuery('.ql-align[value="right"]').attr('aria-label', this.$lang('Wyrównanie do prawej'));
        jQuery('.ql-align[value=""]').attr('aria-label', this.$lang('Wyrównanie do lewej'));
        jQuery('.ql-blockquote').attr('aria-label', this.$lang('Cudzysłów'));
        jQuery('.ql-code-block').attr('aria-label', this.$lang('Blok kodu'));
        jQuery('.ql-list[value="ordered"]').attr('aria-label', this.$lang('Lista numerowana'));
        jQuery('.ql-list[value="bullet"]').attr('aria-label', this.$lang('Lista nienumerowana'));
        jQuery('.ql-list[value="check"]').attr('aria-label', this.$lang('Lista z checkboxami'));
        jQuery('.ql-indent[value="-1"]').attr('aria-label', this.$lang('Wcięcie do lewej'));
        jQuery('.ql-indent[value="+1"]').attr('aria-label', this.$lang('Wcięcie do prawej'));

        jQuery('.ql-color .ql-picker-item').each(function (index, element) {
            let item = $(element);
            let desc = '';
            if (index === 0) {
                desc = component.$lang('Kolor w systemie szesnastkowym') + ' ' + '#000';
            } else {
                desc = component.$lang('Kolor w systemie szesnastkowym') + ' ' + item.attr('data-value');
            }
            item.attr('aria-label', desc);
        });

        jQuery('.ql-color .ql-picker-label').attr('aria-label', this.$lang('Kolor tekstu'));
        jQuery('.ql-background .ql-picker-item').each(function (index, element) {
            let item = $(element);
            let desc = '';
            if (index === 0) {
                desc = component.$lang('Kolor w systemie szesnastkowym') + ' ' + '#000';
            } else {
                desc = component.$lang('Kolor w systemie szesnastkowym') + ' ' + item.attr('data-value');
            }
            item.attr('aria-label', desc);
        });
        jQuery('.ql-background .ql-picker-label').attr('aria-label', this.$lang('Kolor tła'));


        jQuery('.ql-link').attr('aria-label', this.$lang('Link'));
        jQuery('.ql-image').attr('aria-label', this.$lang('Obraz'));
        jQuery('.ql-video').attr('aria-label', this.$lang('Wideo'));
        jQuery('.ql-clean').attr('aria-label', this.$lang('Wyczyść style'));
        jQuery('img').addClass("img-responsive");
    },
};
